/* =========================================================
   Preguntas sobre el rol que se hacen en varias pantallas.

   Existe porque la respuesta estaba escrita como `role === 'SITE_MGR'`
   en seis sitios, y al aparecer SITE_ADMIN —que también tiene un solo
   site— cada uno de esos seis había que encontrarlo y corregirlo. Con
   un nombre, el próximo rol que se añada se cambia aquí.
   ========================================================= */
import type { AuthPolicy, ManagedRole, Role, SessionUser } from '@/types';

/** ¿El alcance de esta cuenta es un site concreto?
 *
 *  Gerente y admin de site tienen los dos un solo centro; lo que los
 *  separa es si pueden escribir en él, y eso lo responde usePuedeEditar,
 *  no esto. Aquí se decide qué datos se le enseñan. */
export const esDeUnSite = (role: Role) => role === 'SITE_MGR' || role === 'SITE_ADMIN';

/** Las organizaciones de una cuenta.
 *
 *  Un gerente del socio puede estar atado a varias, así que devuelve la
 *  lista entera y no una sola. Vivía en `seed.ts`, entre los datos de
 *  ejemplo, pero la usan ocho pantallas del portal real. */
export function userOrgIds(user: SessionUser | null | undefined): string[] {
  if (!user) return [];
  if (Array.isArray(user.orgIds) && user.orgIds.length) return user.orgIds;
  return user.orgId ? [user.orgId] : [];
}

/** Qué métodos de acceso admite cada tipo de cuenta.
 *
 *  'required' = siempre encendido y no se puede quitar · 'optional' = la
 *  persona lo activa si quiere · 'off' = no está permitido.
 *
 *  El Admin ETC exige segundo factor: es la cuenta que lo ve todo. */
export const AUTH_POLICY: Record<ManagedRole, AuthPolicy> = {
  ETC_ADMIN:   { password: 'required', twoFactor: 'required', microsoft: 'optional' },
  PARTNER_MGR: { password: 'required', twoFactor: 'optional', microsoft: 'optional' },
  SITE_MGR:    { password: 'required', twoFactor: 'optional', microsoft: 'optional' },
  SITE_ADMIN:  { password: 'required', twoFactor: 'optional', microsoft: 'optional' },
  INSTRUCTOR:  { password: 'required', twoFactor: 'off',      microsoft: 'optional' },
};
